import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import { CookiesProvider } from "react-cookie";

const domain = process.env.REACT_APP_AUTHDOMAIN;
const clientId = process.env.REACT_APP_AUTHCLIENTID;
const audience = process.env.REACT_APP_AUTHAUDIENCE;

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    audience={audience}
    redirectUri={window.location.origin}
  >
    <CookiesProvider>
      <App />
    </CookiesProvider>
  </Auth0Provider>
);
